export enum Affiliate {
  tatrabanka = 'tatrabanka',
  saashub = 'saashub',
  ttb = 'ttb',
  londonOffice = 'londonOffice',
  businify = 'businify',
  setUpToSucceed = 'setUpToSucceed',
  vliani = 'vliani',
  ionos = 'ionos',
  simoneGiertz = 'simoneGiertz',
  monicaRazak = 'monicaRazak',
  coleHastings = 'coleHastings',
  grantRudow = 'grantRudow',
  crayonCapital = 'crayonCapital',
  fbaZip = 'fbaZip',
  firstFormations = '1stFormations',
  casualFinance = 'casualFinance',
  michaelGirdley = 'michaelGirdley',
  ourCheeryCorner = 'ourCheeryCorner',
  legalEagle = 'legalEagle',
  monkeyExplains = 'monkeyExplains',
  vantaflow = 'vantaflow',
  hfcs = 'hfcs',
  loosends = 'loosends',
  taylahRose = 'taylahRose',
  earlyExit = 'earlyExit',
}

export const affiliateConfig: Record<
  Affiliate,
  {discountCoupon: string; discountPercentage?: number; discountPrice?: number}
> = {
  [Affiliate.tatrabanka]: {
    discountCoupon: 'TATRABANKA30',
    discountPercentage: 30,
  },
  [Affiliate.ttb]: {
    discountCoupon: 'TATRABANKA30',
    discountPercentage: 30,
  },
  [Affiliate.saashub]: {
    discountCoupon: 'SAASHUB20',
    discountPercentage: 20,
  },
  [Affiliate.londonOffice]: {
    discountCoupon: 'TLO20OFF',
    discountPercentage: 20,
  },
  [Affiliate.businify]: {
    discountCoupon: 'BUSINIFY15',
    discountPercentage: 15,
  },
  [Affiliate.setUpToSucceed]: {
    discountCoupon: 'FORD20',
    discountPercentage: 20,
  },
  [Affiliate.vliani]: {
    discountCoupon: 'VLIANI30',
    discountPercentage: 30,
  },
  [Affiliate.ionos]: {
    discountCoupon: 'IONOS50',
    // Discount price:
    // - it is a static price, so regardless of the client's currency change, the discount will remain fixed at 50 (USD, EUR, CZK, etc.)
    // - it is acceptable as Ionos will promote it only to the US customers
    discountPrice: 50,
  },
  [Affiliate.simoneGiertz]: {
    discountCoupon: 'SIMONE20',
    discountPercentage: 20,
  },
  [Affiliate.monicaRazak]: {
    discountCoupon: 'MONICA20',
    discountPercentage: 20,
  },
  [Affiliate.coleHastings]: {
    discountCoupon: 'HASTINGS20',
    discountPercentage: 20,
  },
  [Affiliate.grantRudow]: {
    discountCoupon: 'GRANT20',
    discountPercentage: 20,
  },
  [Affiliate.crayonCapital]: {
    discountCoupon: 'CRAYON20',
    discountPercentage: 20,
  },
  [Affiliate.fbaZip]: {
    discountCoupon: 'FBAZIP10',
    discountPercentage: 10,
  },
  [Affiliate.firstFormations]: {
    discountCoupon: '1STFORMATIONS10',
    discountPercentage: 10,
  },
  [Affiliate.casualFinance]: {
    discountCoupon: 'CASUAL20',
    discountPercentage: 20,
  },
  [Affiliate.michaelGirdley]: {
    discountCoupon: 'MICHAEL20',
    discountPercentage: 20,
  },
  [Affiliate.ourCheeryCorner]: {
    discountCoupon: 'CHEERY20',
    discountPercentage: 20,
  },
  [Affiliate.legalEagle]: {
    discountCoupon: 'EAGLE20',
    discountPercentage: 20,
  },
  [Affiliate.monkeyExplains]: {
    discountCoupon: 'MONKEY20',
    discountPercentage: 20,
  },
  [Affiliate.vantaflow]: {
    discountCoupon: 'VANTAFLOW10',
    discountPercentage: 10,
  },
  [Affiliate.hfcs]: {
    discountCoupon: 'HFCS15',
    discountPercentage: 15,
  },
  [Affiliate.loosends]: {
    discountCoupon: 'LOOSENDS20',
    discountPercentage: 20,
  },
  [Affiliate.taylahRose]: {
    discountCoupon: 'TAYLAH20',
    discountPercentage: 20,
  },
  [Affiliate.earlyExit]: {
    discountCoupon: 'EARLYEXIT20',
    discountPercentage: 20,
  },
} as const
